export default __webpack_public_path__ + "static/media/icons-project-drawing.547e917c.svg";